/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    'use strict';

    $('#selectTemplate').on('change', function () {
        $('.donnees_template').addClass('masquer');
        $('#' + this.value).removeClass('masquer');
    }).triggerHandler('change');

    $('.fileupload').each(function () {
        $(this).fileupload({'name': $(this).data('name')});
    });

    $('[data-dismiss="fileupload"]').on('click', function () {
        var nomElementLie = $(this).data('hiddeninputname');
        $('#' + nomElementLie).val('');
    });

})(jQuery.noConflict());
